
export default {
  name: 'BrandBannerImage',
  props: {
    bgLogo: {
      type: Object,
      default() { return {}; },
    },
    bgImage: {
      type: Object,
      default() { return {}; },
    },
    title: {
      type: String,
    },
    isCollectionPage: {
      type: Boolean,
      default: false,
    },
    isBannerTop: {
      type: Boolean,
      default: false,
    },
  },
};
